import { useBatchSkiptraceStore } from 'features/BatchSkiptrace/infra/views/BatchSkiptraceStore/BatchSkiptraceStoreLive'

export const useDownloadBatchSkiptraceState = () =>
  useBatchSkiptraceStore(store => store.download.state)
